/**
 * Constantes de roles/permisos del sistema.
 * Convencion: `role<Modulo><Accion>` donde CREAR = editar, LECTURA = acceso.
 */
export const Roles = {
  // roles crear = editar
  roleTareasCrear: 'ROLE_TAREAS_CREAR',
  roleSitiosCrear: 'ROLE_SITIOS_CREAR',
  roleAutorizacionesCrear: 'ROLE_AUTORIZACIONES_CREAR',
  roleCondicionantesCrear: 'ROLE_CONDICIONANTES_CREAR',
  roleCatalogosCrear: 'ROLE_CATALOGOS_CREAR',
  roleCalendarioCrear: 'ROLE_CALENDARIO_CREAR',
  roleUsuariosCrear: 'ROLE_USUARIOS_CREAR',
  // roles lectura = acceso
  roleTareasLectura: 'ROLE_TAREAS_LECTURA',
  roleSitiosLectura: 'ROLE_SITIOS_LECTURA',
  roleAutorizacionesLectura: 'ROLE_AUTORIZACIONES_LECTURA',
  roleCondicionantesLectura: 'ROLE_CONDICIONANTES_LECTURA',
  roleCatalogosLectura: 'ROLE_CATALOGOS_LECTURA',
  roleCalendarioLectura: 'ROLE_CALENDARIO_LECTURA',
  roleUsuariosLectura: 'ROLE_USUARIOS_LECTURA',
}
